import React, { Component } from 'react';

import Checkbox from 'bz-core-controls/controls/next/form/checkbox';
import { observable } from 'mobx';

interface IAddressAttributesProps {
  store: any;
  onChange: (value: any) => void;
  value: any;
}

class AddressAttributes extends Component<IAddressAttributesProps> {
  static defaultProps = {
    value: {
      addressLine1: false,
      addressLine2: false,
      town: false,
      country: false,
      county: false,
      postcode: false
    }
  };

  @observable requiredFields: {
    addressLine1: boolean;
    addressLine2: boolean;
    town: boolean;
    country: boolean;
    county: boolean;
    postcode: boolean;
  } = {
    addressLine1: false,
    addressLine2: false,
    town: false,
    country: false,
    county: false,
    postcode: false
  };

  constructor(props: IAddressAttributesProps) {
    super(props);
    let requiredFields = this.requiredFields;
    if (props.value != null) {
      requiredFields = props.value.requiredFields;
    }
    this.requiredFields = requiredFields;
  }

  onRequiredFieldsChange(property: string, e: any) {
    this.requiredFields[property] = e.target.checked;
    this.props.onChange({ requiredFields: this.requiredFields });
  }

  render() {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', width: '240px' }}>
        <Checkbox
          label="Address"
          onChange={this.onRequiredFieldsChange.bind(this, 'addressLine1')}
          checked={this.requiredFields.addressLine1}
        />
        <Checkbox
          label="Address 2"
          onChange={this.onRequiredFieldsChange.bind(this, 'addressLine2')}
          checked={this.requiredFields.addressLine2}
        />
        <Checkbox
          label="Town"
          onChange={this.onRequiredFieldsChange.bind(this, 'town')}
          checked={this.requiredFields.town}
        />
        <Checkbox
          label="Country"
          onChange={this.onRequiredFieldsChange.bind(this, 'country')}
          checked={this.requiredFields.country}
        />
        <Checkbox
          label="County"
          onChange={this.onRequiredFieldsChange.bind(this, 'county')}
          checked={this.requiredFields.county}
        />
        <Checkbox
          label="Postcode"
          onChange={this.onRequiredFieldsChange.bind(this, 'postcode')}
          checked={this.requiredFields.postcode}
        />
      </div>
    );
  }
}

export default AddressAttributes;
